import { render, staticRenderFns } from "./drawer-lang-selector.vue?vue&type=template&id=7596278f&"
import script from "./drawer-lang-selector.vue?vue&type=script&lang=ts&"
export * from "./drawer-lang-selector.vue?vue&type=script&lang=ts&"
import style0 from "./drawer-lang-selector.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports